import type {
  IGenerateAnimationData,
  IGetBackgroundAndSvg,
} from 'pages/login/login-types';

import { generateAnimationData, getBackgroundAndSvg } from 'pages/login/helpers';

export interface IAuthBgConfig extends IGetBackgroundAndSvg, IGenerateAnimationData {}

const { bgCode, background, svgString } = getBackgroundAndSvg();
const { animationDuration, animationNumber } = generateAnimationData();

const initialState: IAuthBgConfig = {
  bgCode,
  background,
  svgString,
  animationDuration,
  animationNumber,
};

export default function defaultExport(state = initialState) {
  return state;
}
